import { render, staticRenderFns } from "./ModalRol.vue?vue&type=template&id=5a2f4b0c&scoped=true"
import script from "./ModalRol.vue?vue&type=script&lang=js"
export * from "./ModalRol.vue?vue&type=script&lang=js"
import style0 from "./ModalRol.vue?vue&type=style&index=0&id=5a2f4b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f4b0c",
  null
  
)

export default component.exports